import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import SingleLead from './singlelead'  

function LeadDetailsPage({ isLoggedIn, uid, plid }) {
    const { country, leadid } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoggedIn || uid === 1) {
            navigate('/signin', { state: { from: `/leaddetails/${country}/${leadid}` } });
            return;
        }
    }, [isLoggedIn, uid, leadid, country, plid]);

    return (
        <Container fluid className="h-100 d-flex flex-column w-100" style={{ background: "var(--bg-wowleads)" }}>
            <SingleLead leadid={leadid} db={country} planid={plid}/>
        </Container>
    );
}

export default LeadDetailsPage;
